export default __webpack_public_path__ + "static/go@992-13a936e98ba9813120cda496a589b917.svg";